import getStore from '../data/store/store';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';

/**
 * Utility function to log the usage of options.
 */
export default function logDataOnSaveAppearance() {
    let currentState = getStore();
    if (!currentState) {
        return;
    }
    logWeekStartDay('WeekStartDay');
    logTimeIncrement();
    logFirstWeekOfYear();
    logWeekNumbers();
    logWorkingHoursStartTime();
    logWorkingHoursEndTime();
    logWorkDay();
}

/**
 * Utility function to log the usage of week start day quick settings.
 */
export function logDataOnSaveWeekStartDayQuickSetting() {
    let currentState = getStore();
    if (!currentState) {
        return;
    }
    logWeekStartDay('WeekStartDayQuick');
}

export function logWeekStartDay(datapointKey: string) {
    let currentState = getStore();
    if (currentState.weekStartDay != null) {
        const customData = datapoints[datapointKey].datapoint.customData(currentState.weekStartDay);
        logUsage(datapoints[datapointKey].datapoint.name, customData);
    }
}

function logTimeIncrement() {
    let currentState = getStore();
    if (currentState.timeIncrement != null) {
        const customData = datapoints.TimeIncrement.datapoint.customData(
            currentState.timeIncrement
        );
        logUsage(datapoints.TimeIncrement.datapoint.name, customData);
    }
}

function logFirstWeekOfYear() {
    let currentState = getStore();
    if (currentState.firstWeekOfYear != null) {
        const customData = datapoints.FirstWeekOfYear.datapoint.customData(
            currentState.firstWeekOfYear
        );
        logUsage(datapoints.FirstWeekOfYear.datapoint.name, customData);
    }
}

function logWeekNumbers() {
    let currentState = getStore();
    if (currentState.showWeekNumbers != null) {
        const customData = datapoints.ShowWeekNumbers.datapoint.customData(
            currentState.showWeekNumbers
        );
        logUsage(datapoints.ShowWeekNumbers.datapoint.name, customData);
    }
}

function logWorkingHoursStartTime() {
    let currentState = getStore();
    if (currentState.workingHoursStartTime != null) {
        const customData = datapoints.WorkingHoursStartTime.datapoint.customData(
            currentState.workingHoursStartTime
        );
        logUsage(datapoints.WorkingHoursStartTime.datapoint.name, customData);
    }
}

function logWorkingHoursEndTime() {
    let currentState = getStore();
    if (currentState.workingHoursEndTime != null) {
        const customData = datapoints.WorkingHoursEndTime.datapoint.customData(
            currentState.workingHoursEndTime
        );
        logUsage(datapoints.WorkingHoursEndTime.datapoint.name, customData);
    }
}

function logWorkDay() {
    let currentState = getStore();
    if (currentState.workDays != null) {
        const customData = datapoints.WorkDays.datapoint.customData(currentState.workDays);
        logUsage(datapoints.WorkDays.datapoint.name, customData);
    }
}
